import React from 'react';
import './LoadingSpinner.css'; // Asegúrate de crear un archivo CSS para los estilos del spinner

const LoadingSpinner = () => (
    <div className="loading-spinner">
        <div className="spinner"></div>
    </div>
);

export default LoadingSpinner;
